import { MessageBar, MessageBarType } from "@fluentui/react";

/**
 * 検索への反映中は、編集を受け付けない。
 * 反映状態を取得できなかった場合(null)も、実行中かどうか判らないため同様に扱う
 */
export const isLockedByIndexer = (isIndexerRunning: boolean | null): boolean => isIndexerRunning !== false

/** 編集を受け付けない理由を示すメッセージ。編集できる場合は何も表示しない */
export const IndexerLockMessageBar = (props: { isIndexerRunning: boolean | null }) => {
    const { isIndexerRunning } = props
    if (isIndexerRunning === false) return null

    return (
        <MessageBar messageBarType={MessageBarType.warning}>
            {isIndexerRunning === null
                ? "検索への反映状態を取得できないため、編集ができません。"
                : "現在ファイルを検索へ反映中のため、編集ができません。"}
            時間をおいて再度アクセスしてください。
        </MessageBar>
    )
}
